import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from '@reduxjs/toolkit';
import { blockApi } from 'farmx-api';
import {
  initialState,
  requestList,
  receiveList,
  requestListFailed,
} from '../helpers';

const name = 'anomaly';

export const anomalyAdapter = createEntityAdapter();

export const loadAnomaliesForBlock = createAsyncThunk(
  `${name}/loadAnomaliesForBlock`,
  async (blockId) => {
    const response = await blockApi.getBlockAnomaly(blockId);
    return response.data;
  },
);

const anomalySlice = createSlice({
  name,
  initialState: anomalyAdapter.getInitialState(initialState),
  reducers: {
    cleanListRequestState(state) {
      state.loading = false;
      state.currentRequestId = undefined;
      state.error = null;
    },
  },
  extraReducers: {
    [loadAnomaliesForBlock.pending]: requestList,
    [loadAnomaliesForBlock.fulfilled]: receiveList(anomalyAdapter),
    [loadAnomaliesForBlock.rejected]: requestListFailed,
  },
});

export { anomalySlice };
export default anomalySlice.reducer;
